import Vue from 'vue'
import Vuex from 'vuex'
import statisticalModule, { moduleName as statisticalModuleName } from './statistical'
import userManagerModule, { moduleName as userManagerModuleName } from './userManager'
import auctionManagerModule, { moduleName as auctionManagerModuleName } from './auctionManager'
import salesRevenueManagerModule, { moduleName as salesRevenueManageModuleName } from './salesRevenueManager'
import managersManagerModule, { moduleName as managersManagerModuleName } from './managersManager'
import carManagerModule, { moduleName as carManagerModuleName } from './carManager'
import authModule, { moduleName as authModuleName } from './auth'
import modalsModule, { moduleName as modalsModuleName } from './modals'
import tableModule, { moduleName as tableModuleName } from './table'
import commentModule, { moduleName as commentModuleName } from './comments'
import supportModule, { moduleName as supportModuleName } from './support'
import blogModule, { moduleName as blogModuleName } from './Blogs'
import auctionBannerModule, { moduleName as auctionBannerModuleName } from './auctionBanner'
import auctionDealersModule, { moduleName as auctionDealersModuleName } from './Dealers'
import auctionPaymentsModule, { moduleName as auctionPaymentsModuleName } from './Payments'
import taxCreditModule, { moduleName as taxCreditModuleName } from './taxCredit'
import marketplaceModule, { moduleName as marketplaceModuleName } from './Marketplace'
import vdpArticleModule, { moduleName as vdpArticleModuleName } from './VdpArticles'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sidebarShow: 'responsive',
    sidebarMinimize: false
  },
  mutations: {
    toggleSidebarDesktop (state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile (state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set (state, [variable, value]) {
      state[variable] = value
    }
  },
  actions: {
  },
  modules: {
    [statisticalModuleName]: statisticalModule,
    [userManagerModuleName]: userManagerModule,
    [auctionManagerModuleName]: auctionManagerModule,
    [carManagerModuleName]: carManagerModule,
    [salesRevenueManageModuleName]: salesRevenueManagerModule,
    [managersManagerModuleName]: managersManagerModule,
    [authModuleName]: authModule,
    [modalsModuleName]: modalsModule,
    [tableModuleName]: tableModule,
    [commentModuleName]: commentModule,
    [supportModuleName]: supportModule,
    [blogModuleName]: blogModule,
    [auctionBannerModuleName]: auctionBannerModule,
    [auctionDealersModuleName]: auctionDealersModule,
    [auctionPaymentsModuleName]: auctionPaymentsModule,
    [taxCreditModuleName]: taxCreditModule,
    [marketplaceModuleName]: marketplaceModule,
    [vdpArticleModuleName]: vdpArticleModule,
  }
})
